<template>
    <label class="settings-checkbox" :class="{ 'is-checked': model }">
        <input type="checkbox" v-model="model">
        <div class="checkbox-container">
            <span class="checkbox-box" :class="{ 'is-circle': uncheckedShape === 'circle' }"></span>
            <i class="el-icon-check"></i>
        </div>
        <span class="label-text">{{ label }}</span>
    </label>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        },
        uncheckedShape: {
            type: String,
            default: 'square',
            validator(value) {
                return ['square', 'circle'].includes(value)
            }
        }
    },
    computed: {
        model: {
            get() {
                return Boolean(this.value)
            },
            set(value) {
                const boolValue = Boolean(value)
                this.$emit('input', boolValue)
                this.$emit('update', boolValue)
            },
        },
    }
}
</script>

<style scoped>
.settings-checkbox {
    display: inline-flex;
    align-items: center;
    background-color: #fff;
    color: #606266;
    padding: 8px 15px;
    border-radius: 5px;
    cursor: pointer;
    user-select: none;
    margin-right: 10px;
    border: 1px solid #dcdfe6;
    transition: all 0.3s;
}

.settings-checkbox:hover {
    background-color: #E6F7ED;
    border-color: #00BF50;
    color: #00854A;
}

.settings-checkbox.is-checked {
    background-color: #00BF50;
    border-color: #00BF50;
}

.settings-checkbox input {
    display: none;
}

.checkbox-container {
    width: 16px;
    margin-right: 8px;
    position: relative;
    height: 16px;
    flex-shrink: 0;
}

.settings-checkbox i {
    font-size: 16px;
    opacity: 0;
    transition: opacity 0.2s;
    color: white;
    position: absolute;
    top: 0;
    left: 0;
}

.settings-checkbox.is-checked i {
    opacity: 1;
}

.settings-checkbox.is-checked .label-text {
    color: white;
}

.checkbox-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 16px;
    height: 16px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    background-color: #fff;
    transition: border-radius 0.3s;
}

.checkbox-box.is-circle {
    border-radius: 50%;
}

.settings-checkbox.is-checked .checkbox-box {
    display: none;
}

.settings-checkbox:hover .checkbox-box {
    border-color: #00BF50;
}

.label-text {
    font-size: 14px;
    color: #606266;
    transition: color 0.3s;
}
</style>
